import { createAction } from 'redux-actions'

export const clearPartner = createAction('CLEAR_PARTNER')
